import { useLayoutEffect } from 'react';

let locks = 0;
let release: (() => void) | undefined;

/** Shared ownership keeps nested inspectors from unlocking an expanded map. */
export function useGameScrollLock(active: boolean) {
  useLayoutEffect(() => {
    if (!active) return;
    if (locks++ === 0) {
      const elements = [document.documentElement, document.body];
      const previous = elements.map(element => element.style.overflow);
      const x = window.scrollX, y = window.scrollY;
      elements.forEach(element => { element.style.overflow = 'hidden'; });
      release = () => {
        elements.forEach((element, index) => { element.style.overflow = previous[index]; });
        if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
      };
    }
    return () => {
      if (--locks === 0) { release?.(); release = undefined; }
    };
  }, [active]);
}
